/**
 * Application theme
 *
 * Override and extend smooth-ui theme values
 * https://github.com/smooth-code/smooth-ui/blob/master/packages/shared/core/theme.js
 * https://smooth-ui.smooth-code.com/
 */

import { transparentize } from 'polished';
import { thd, theme } from '@smooth-ui/core-sc';
import settingsApp from 'theme/settingsApp';

/*
If overwriting the default Smooth-UI theme properties, and you're planning on
re-using them throughout the default export below, make sure to define them in
the outer scope, otherwise components attempting to use the value with throw errors
*/
const primary = '#CE1723';
const secondary = '#192170';
const grey = '#54707C';
const bluegrey = '#87B1C3';
const green = '#CE1723';
const text = '#131D28';

export default {
  // Mandatory
  ...theme,
  settingsApp, // Bring in the merged app settings

  // Resets
  borderRadius: 0,
  error: thd('danger', '#dc3545'),
  gridMaxWidths: { sm: '100%', md: '100%', lg: '100%', xl: '1200px' },
  primary: primary,
  secondary: secondary,
  text: text,
  grey: grey,
  bluegrey: bluegrey,
  green: green,

  // Layout
  borderColor: thd('gray300', '#ddd'),
  containerWidth: '1200px',

  // Colours
  defaultFontColor: theme.gray800,
  defaultLinkColor: grey,
  // pointsValueColor: '#f90',

  // Input + Buttons
  inputBtnMinWidth: '175px',
  customInputHintColor: theme.gray600,
  customInputHintFontSize: '.875em',
  customInlineInputInvalidColor: theme.red, //unused
  customCheckboxDisabledBackground: '#ced4da',

  // Header + Menu
  customHeaderBackground: primary,
  customHeaderColor: '#fff',
  customMenuBackground: primary,
  customMenuColor: '#fff',
  customMenuHighlight: secondary, // unused
  customMenuHighlightColor: '#fff',
  customMenuFocus: transparentize(0.75, primary),
  customSubMenuBackground: secondary,
  customMobileMenuOverlayBackground: 'rgba(0, 0, 0, 0.5)',

  // Loading animations
  loadingBarColor: primary || '#f4bd19',
  loadingSpinnerPrimary: '#555',
  loadingSpinnerSecondary: '#eee',

  // Welcome component
  welcomeBackground: '#192170',
  welcomeColor: '#fff',
  welcomeHighlight: '#fff',

  // Breadcrumbs
  breadcrumbsBackground: 'transparent',
  breadcrumbsColor: 'black',
  breadcrumbsContainerWidth: thd('containerWidth', '100%'),
  breadcrumbsLinkColor: 'black',
  breadcrumbsLinkHoverColor: primary,
  breadcrumbsCurrentLinkColor: thd('gray800', '#333'),
  breadcrumbsFontSize: '14px',

  // Cart
  // miniCartBackground: '#fff',
  cartBadgeBackground: primary,
  cartBadgeColor: '#fff',
  cartPointsBalanceBackground: secondary,
  cartRemainingNegativeColor: thd('danger', '#dc3545'),

  // Rewards
  rewardCategoriesListContainerWidth: thd('containerWidth', '100%'),
  rewardCategoriesFilterContainerWidth: thd('containerWidth', '100%'),
  rewardListContainerWidth: thd('containerWidth', '100%'),
  rewardDetailContainerWidth: thd('containerWidth', '100%'),
  rewardDescription1ContainerWidth: thd('containerWidth', '100%'),
  rewardDescription2ContainerWidth: thd('containerWidth', '100%'),

  // Rewards - Quickview
  // quickviewBackground: '#333',
  // quickviewColor: '#fff',

  // Rewards - Wishlist
  miniWishlistBackground: '#fff',
  wishlistBadgeBackground: primary,
  wishlistBadgeColor: '#fff',
  wishlistContainerWidth: '500px',
  wishlistIconActive: primary,
  wishlistIconInactive: '#32343B',
  wishlistIconHover: grey,

  // Rewards - Highlight (featured/related rewards)
  rewardsHighlightBackground: '#fff',
  rewardsHighlightContainerWidth: thd('containerWidth', '100%'),

  // Statement
  statementHighlightColor: primary,
  statementStatus: {
    achieved: '#1e967a',
    onTrack: '#1e967a',
    close: '#ea7c22',
    behind: '#dc402a',
    inProgress: '#ea7c22',
    timeElapsed: '#32343b',
  },
  statementDoughnutBorder: '#eaeaeb',
  statementDoughnutRemainingTrack: secondary,

  // Tooltips
  tooltipBackground: '#fff',
  tooltipBorderColor: '#fff',
  tooltipColor: thd('defaultFontColor', theme.gray800),

  // Pagination
  pagerActiveBackground: 'rgba(0,0,0,0.125)',
  pagerActiveColor: '#fff',
  // pagerColor: thd('gray800', 'inherit'),
  pagerBackgroundHover: 'rgba(0,0,0,0.125)',
};
